import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Modal, ModalBody, Button } from "reactstrap";
import moment from "moment";

import CloseIcon from "../../images/close-button-search.png";

import { fetchShippingTracking } from "../../actions/dashboardAction";
import { functions } from "firebase";

const ModalTrackingNumber = ({
  saleId, 
  status, 
  orderId,
  deliverAt,
  shippingCourier,
  awbNumber,
  ...props
}) => {
  useEffect(() => {
    props.fetchShippingTracking(saleId, { status });
  }, [saleId]);

  const [isConfirm, setConfirm] = useState(false);
  
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.onToggle}
      className={`kick-modal detail-selling ${
        status === "seller" ? "tracking-number-selling-modal" : ""
      }`}
      style={{
        marginTop: status === "seller" ? 0 : isConfirm ? "40vh" : "15vh",
      }}
    >
      {!isConfirm || status === "seller" ? (
        <>
          <div className="header-expiry">
            <div className="tracking-wrapper">
              <span>TRACKING</span>
            </div>
            <div className="close-icon-wrapper">
              <KickImage
                onClick={props.onToggle}
                src={CloseIcon}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <ModalBody className="body-tracking">
            <Row className="body-tracking-content">
              <Col className="body-tracking-content-point">
                <span>ORD ID:</span>
                <span>{orderId ? orderId : "-"}</span>
              </Col>
              <Col className="body-tracking-content-point">
                <span>Delivered at:</span>
                <span>
                  {deliverAt
                    ? moment(deliverAt).format(
                        "DD/MM/YYYY"
                      )
                    : "-"}
                </span>
              </Col>
              <Col className="body-tracking-content-point">
                <span>Shipping Courier:</span>
                <span>
                  {shippingCourier ? shippingCourier : "-"}
                </span>
              </Col>
              <Col className="body-tracking-content-point">
                <span>AWB NUMBER:</span>
                <span>
                  {awbNumber ? awbNumber : "-"}
                </span>
              </Col>
              <Col className="body-tracking-content-point tracking-history">
                <span className="delivery-status-text">Delivery Status:</span>
                <div className="order-track-wrapper">
                  <div className="order-track">
                    {props.dataTracking &&
                      props.dataTracking.data &&
                      props.dataTracking.data.history.length > 0 &&
                      props.dataTracking.data.history.map((history, i) => {
                        return (
                          <div className="order-track-step" key={i}>
                            <div className="order-track-status">
                              {i == 0 ? (
                                <span className="order-track-status-dot green"></span>
                              ) : (
                                <span className="order-track-status-dot"></span>
                              )}
                              <span className="order-track-status-line"></span>
                            </div>
                            <div className="order-track-text">
                              {i == 0 ? (
                                <p className="order-track-text-stat green-text">
                                  {history.description &&
                                  history.description.split(" ").length > 1
                                    ? history.description
                                    : history.location}
                                </p>
                              ) : (
                                <p className="order-track-text-stat">
                                  {history.description &&
                                  history.description.split(" ").length > 1
                                    ? history.description
                                    : history.location}
                                </p>
                              )}
                              <span
                                style={{
                                  fontFamily: "Nunito Regular",
                                  fontWeight: "500",
                                }}
                                className="order-track-text-sub"
                              >
                                {history.logged_at}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </Col>
            </Row>
            {status === "buyer" && (
              <Row
                style={{
                  paddingTop: "0.6rem",
                  marginBottom: "-0.8rem",
                  borderTop: "1px solid #ebebeb",
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  boxShadow: "0 1px 6px 0 rgba(0, 0, 0, 0.16)",
                }}
              >
                <Col
                  style={{
                    alignItems: "center",
                    paddingBottom: 0,
                    borderBottom: 0,
                  }}
                >
                  <Button
                    className="btn-green flat"
                    style={{
                      width: "100%",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => setConfirm(true)}
                  >
                    Package Received
                  </Button>
                </Col>
              </Row>
            )}
          </ModalBody>
        </>
      ) : (
        <ModalBody className="confirmation-page">
          <h6 style={{ fontSize: "12px" }}>Package Received</h6>
          <p>Have you already received the package?</p>
          <div className="button-page-container">
            <Button
              className="button-no"
              onClick={() => setConfirm(false)}
              style={{ fontSize: "12px" }}
            >
              NO
            </Button>

            <Button
              className="button-yes"
              onClick={() => {
                props.submitReceive(saleId);
              }}
              style={{ fontSize: "12px" }}
            >
              YES
            </Button>
          </div>
        </ModalBody>
      )}
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  dataTracking: state.dataHistory.shippingTrackingData
});

const mapDispatchToProps = {
  fetchShippingTracking,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalTrackingNumber);
